import { Leaf } from "@phosphor-icons/react";
import { dietListLabel } from "@/lib/diets";

// Slim note shown when a cook's saved diet profile is filtering results.
export const DietProfileNote = ({ diets, onShowAll }) => {
  if (!diets?.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 mb-5 rounded-xl bg-emerald-50 border border-emerald-600/25 px-4 py-2 text-sm text-emerald-950" data-testid="diet-profile-note" role="status">
      <Leaf size={14} weight="fill" className="text-emerald-700 shrink-0" aria-hidden="true" />
      <span>Showing <b>{dietListLabel(diets).replace(" and ", " + ")}</b> only (from your diet profile)</span>
      <button type="button" onClick={onShowAll} data-testid="diet-profile-show-all" className="font-bold underline hover:no-underline ml-1">Show everything</button>
    </div>
  );
};
